/**
 * Vision coverage skeleton
 *
 * Provides the default structure for a new Vision coverage/benefit plan.
 */

import { BaseBenefitPlanPolicyPeriod } from "@platform/openapi-types";

import {
  BenefitPlanTypeEnum,
  CoverageTypeEnum,
  PlanOptionNameEnum,
  RfpBenefitPlan,
  RfpCoverage,
} from "../../types/rfp.api.types";

export const getVisionSkeleton = (): Partial<RfpCoverage> => ({
  type: CoverageTypeEnum.VISION,
  status: "quoted",
  notes: "",
  benefitPlans: [
    {
      identifier: "vision-plan-1",
      name: "Vision Plan",
      numberOfLives: 0,
      type: BenefitPlanTypeEnum.PPO,
      policyPeriod: BaseBenefitPlanPolicyPeriod.current,
      currentCarrierName: "",
      fundingType: undefined,
      participationRequirements: "",
      rateGuarantee: undefined,
      rateCap: "",
      optionName: PlanOptionNameEnum.NOT_APPLICABLE,
      benefitClassAvailability: [],
      rateSchedule: [],
      benefits: {
        objectType: "vision",

        // Network Name
        networkName: "",

        // Exam Copay
        examCopayType: undefined,
        examCopayAmount: undefined,

        // Materials Copay
        materialsCopayType: undefined,
        materialsCopayAmount: undefined,

        // Single Lenses
        singleLensesType: undefined,
        singleLensesCopayAmount: undefined,
        singleLensesAllowanceAmount: undefined,

        // Bifocal Lenses
        bifocalLensesType: undefined,
        bifocalLensesCopayAmount: undefined,
        bifocalLensesAllowanceAmount: undefined,

        // Trifocal Lenses
        trifocalLensesType: undefined,
        trifocalLensesCopayAmount: undefined,
        trifocalLensesAllowanceAmount: undefined,

        // Lenticular Lenses
        lenticularLensesType: undefined,
        lenticularLensesCopayAmount: undefined,
        lenticularLensesAllowanceAmount: undefined,

        // Standard Progressive
        standardProgressiveType: undefined,
        standardProgressiveCopayAmount: undefined,
        standardProgressiveAllowanceAmount: undefined,

        // Standard Frames
        standardFramesType: undefined,
        standardFramesCopayAmount: undefined,
        standardFramesAllowanceAmount: undefined,

        // Additional Discounts on Frames
        additionalDiscountsOnFramesType: undefined,
        additionalDiscountsOnFramesAmount: undefined,

        // Contact Lens Elective
        contactLensElectiveType: undefined,
        contactLensElectiveCopayAmount: undefined,
        contactLensElectiveAllowanceAmount: undefined,

        // Contact Lens Exam
        contactLensExamType: undefined,
        contactLensExamCopayAmount: undefined,
        contactLensExamAllowanceAmount: undefined,

        // Frequencies
        examFrequency: undefined,
        lensesFrequency: undefined,
        framesFrequency: undefined,

        // Administrative
        annualOpenEnrollment: undefined,
        employerContribution: undefined,

        // Extended (non-v5) fields — CD-1661/CD-1983
        premiumProgressiveType: undefined,
        premiumProgressiveCopayAmount: undefined,
        premiumProgressiveAllowanceAmount: undefined,
        conventionalContactType: undefined,
        conventionalContactAdditionalDiscountAmount: undefined,
        conventionalContactAllowanceAmount: undefined,
        disposableContactType: undefined,
        disposableContactCopayAmount: undefined,
        disposableContactAllowanceAmount: undefined,
        contactLensMedNecType: undefined,
        contactLensMedNecCopayAmount: undefined,
        contactLensMedNecAllowanceAmount: undefined,
        progressiveLensesType: undefined,
        progressiveLensesCopayAmount: undefined,
        progressiveLensesAllowanceAmount: undefined,
        eligibilityHours: undefined,
      },
    } as RfpBenefitPlan,
  ],
});
